import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DocumentLibraryConstants } from '../document-library-constants';
import { QuizCreatorComponent } from '../../shared-components/quiz-creator/quiz-creator.component';
import { DocumentProficiencyQuiz } from '../models/document-proficiency-quiz';
import { DocumentDetailDto } from '../models/document-details-DTO';
import { DocumentService } from '../services/document.service';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-document-proficiency-quiz-slider',
  templateUrl: './document-proficiency-quiz-slider.component.html',
  styleUrls: ['./document-proficiency-quiz-slider.component.scss']
})
export class DocumentProficiencyQuizSliderComponent implements OnInit {
  @Input() documentDetailsDto!: DocumentDetailDto;
  @Input() isDocumentProficiencyQuizSliderOpen: boolean = false;
  @Output() isDocumentProficiencyQuizSliderActive = new EventEmitter<boolean>();
  requiresProficiencyQuiz: boolean = false;
  minimumPassingScore: number | null = null;
  maxOfAttempts: number | null = null;
  quiz: string | null = null;
  topBarTitle: string = DocumentLibraryConstants.Document_Proficiency_Quiz_Title;
  documentProficiencyQuiz: DocumentProficiencyQuiz = {} as DocumentProficiencyQuiz;
  documentProficiencyQuizPersistedDetails: DocumentProficiencyQuiz = {} as DocumentProficiencyQuiz;
  errorMessages: string[] = [];
  loadQuizCreator: boolean = false;
  errorMessageHeaderText = DocumentLibraryConstants.Document_Proficiency_Quiz_ErrorText;
  isMinimumPassingScoreValid: boolean = true;
  showDocumentProficiencyQuizLoader: boolean = false;
  spinnerMessage: string = '';
  @ViewChild(QuizCreatorComponent)
  private quizCreatorComponent!: QuizCreatorComponent;
  @Output() numberOfQuizAttemptsAvailable = new EventEmitter<any>();
  @Output() quizData = new EventEmitter<any>();

  constructor(private documentService: DocumentService,
    private confirmationService: ConfirmationService, private messageService: MessageService) { }

  ngOnInit(): void {
    this.getDocumentProficiencyQuizDetails();
  }

  onMinimumPassingScoreChange = (keyEvent: any) => {
    if (Number(keyEvent.target.value) < 0) {
      this.minimumPassingScore = 0;
    }
    else if (Number(keyEvent.target.value) > 100) {
      this.minimumPassingScore = 100;
    }
    else if (keyEvent.target.value === "") {
      this.minimumPassingScore = null;
    }
  }
  onMaxOfAttemptsChange = (keyEvent: any) => {
    if (keyEvent.target.value === "") {
      this.maxOfAttempts = null;
    }else if (Number(keyEvent.target.value) < 1) {
      this.maxOfAttempts = 1;
    }
  }

  enableOrDisableQuizSection = () => {
    if (this.requiresProficiencyQuiz) {
      this.minimumPassingScore = this.documentProficiencyQuizPersistedDetails.minimumPassingScore;
      this.maxOfAttempts = this.documentProficiencyQuizPersistedDetails.maximumAttempts;
      this.quiz = this.documentProficiencyQuizPersistedDetails.quiz;
      this.loadQuizCreator = true;
    } else {
      this.minimumPassingScore = null;
      this.maxOfAttempts = null;
      this.quiz = null;
      this.loadQuizCreator = false;
    }
  }

  saveProficiencyQuiz() {
    if (this.requiresProficiencyQuiz) {
      this.quiz = this.quizCreatorComponent.getQuizDetails();
    }
    if (this.validateProficiencyQuiz()) {
      this.prepareDocumentProficiencyQuizEntityToSave();
      this.showDocumentProficiencyQuizLoader = true;
      this.spinnerMessage = this.documentProficiencyQuiz.documentProficiencyQuizId === null ?
        DocumentLibraryConstants.Document_Proficieny_Quiz_Save_Progress : DocumentLibraryConstants.Document_Proficieny_Quiz_Uodate_Progress;
      this.documentService.saveDocumentProficiencyQuiz(this.documentProficiencyQuiz).subscribe((quizDetails) => {
        this.documentProficiencyQuizPersistedDetails = quizDetails;
        this.closeSlider();
        this.showToastrMessageOnSave();
        this.showDocumentProficiencyQuizLoader = false;
      });
    }
  }

  validateProficiencyQuiz = (): boolean => {
    this.errorMessages = [];
    this.isMinimumPassingScoreValid = true;
    let isProficiencyQuizValid = true;
    if (this.requiresProficiencyQuiz) {
      if (this.minimumPassingScore === null) {
        this.errorMessages.push(this.getErrorMessageText('minimumPassingScore'));
        this.isMinimumPassingScoreValid = false
      }
      if (this.quiz === null || this.quiz === '"{}"') {
        this.errorMessages.push(this.getErrorMessageText('quiz'));
      }
      return isProficiencyQuizValid = !(this.errorMessages.length > 0);
    };
    return isProficiencyQuizValid;
  }

  prepareDocumentProficiencyQuizEntityToSave = () => {
    this.documentProficiencyQuiz.documentProficiencyQuizId = this.documentProficiencyQuizPersistedDetails.documentProficiencyQuizId;
    this.documentProficiencyQuiz.documentNumber = this.documentDetailsDto.number;
    this.documentProficiencyQuiz.documentVersion = Number(this.documentDetailsDto.version);
    this.documentProficiencyQuiz.requiresProficiencyQuiz = this.requiresProficiencyQuiz;
    this.documentProficiencyQuiz.maximumAttempts = this.requiresProficiencyQuiz ?
      this.maxOfAttempts : this.documentProficiencyQuizPersistedDetails.maximumAttempts;
    this.documentProficiencyQuiz.minimumPassingScore = this.requiresProficiencyQuiz ?
      this.minimumPassingScore : this.documentProficiencyQuizPersistedDetails.maximumAttempts;;
    this.documentProficiencyQuiz.quiz = this.requiresProficiencyQuiz ?
      this.quiz : this.documentProficiencyQuizPersistedDetails.quiz;
  }

  getDocumentProficiencyQuizDetails = () => {
    this.spinnerMessage = DocumentLibraryConstants.Document_Proficieny_Quiz_Details_Loading;
    this.showDocumentProficiencyQuizLoader = true;
    this.documentService.getDocumentProficiencyQuizDetails(this.documentDetailsDto.number,
      Number(this.documentDetailsDto.version)).subscribe((response) => {
        this.documentProficiencyQuizPersistedDetails = response;
        this.setProficiencyQuizSliderProperties();
        this.showDocumentProficiencyQuizLoader = false;
        this.loadQuizCreator = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz;
        this.quizData.emit(this.documentProficiencyQuizPersistedDetails);
      });
  }

  confirm = () => {
    this.confirmationService.confirm({
      header: DocumentLibraryConstants.DocumentProficiencyQuiz_Slider_Confirmation_Header,
      message: DocumentLibraryConstants.DocumentProficiencyQuiz_Slider_Confirmation_Text,
      icon: "pi pi-exclamation-triangle",
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.closeSlider();
      }
    });
  }

  closeSlider = () => {
    this.resetQuizCreatorSlider();
    this.isDocumentProficiencyQuizSliderOpen = false;
    this.isDocumentProficiencyQuizSliderActive.emit(this.isDocumentProficiencyQuizSliderOpen);
  }

  resetQuizCreatorSlider = () => {
    this.setProficiencyQuizSliderProperties();
    this.loadQuizCreator = false;
  }

  private getErrorMessageText(labelName: string): string {
    const errorLabelMapper: { [key: string]: string } = {
      minimumPassingScore: DocumentLibraryConstants.Document_Proficiency_Quiz_Min_Passing_Score_Required,
      quiz: DocumentLibraryConstants.Document_Proficiency_Quiz_Section_Required,
    };
    return errorLabelMapper[labelName];
  }

  private showToastrMessageOnSave = () => {
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Success,
      summary: DocumentLibraryConstants.Document_Proficiency_Quiz_Saved_Success
    });
  }

  private setProficiencyQuizSliderProperties = () => {
    this.requiresProficiencyQuiz = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz;
    this.maxOfAttempts = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz ?
      this.documentProficiencyQuizPersistedDetails.maximumAttempts : null;
    this.minimumPassingScore = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz ?
      this.documentProficiencyQuizPersistedDetails.minimumPassingScore : null;
    this.quiz = this.documentProficiencyQuizPersistedDetails.requiresProficiencyQuiz ?
      this.documentProficiencyQuizPersistedDetails.quiz : null;
  }
}
